import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {IErrorResponse} from "../../../../../../../types";
import {
    deletedClassrooms, deletedRestoreClassrooms,
    setClassrooms, setClassroomsRestore, updateClassrooms
} from "../store/classroomsSlice";
import {IClassroomsCreate, IClassroomsPayload, IEquipmentsPayload} from "../types";
import {IChildClassRoomCreate} from "../components/ClassroomsChildTable/types";

const GetClassrooms= createAsyncThunk(
    "get/classrooms",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/classrooms");

            dispatch(setClassrooms(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const SetClassrooms= createAsyncThunk(
    "create/classrooms",
    async ( data:IClassroomsCreate ,{rejectWithValue}) => {
        try {
            const response = await request.post("/classrooms", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditClassrooms = createAsyncThunk(
    "edit/classrooms",
    async ( data :IClassroomsPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/classrooms/${data.id}`, data);
            dispatch(updateClassrooms(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteClassrooms= createAsyncThunk(
    "delete/classrooms",
    async (id:number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/classrooms/${id}`);
            dispatch(deletedClassrooms(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteClassrooms = createAsyncThunk(
    "get/delete/classrooms",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/classrooms/deleted-items`);
            dispatch(setClassroomsRestore(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const RestoreDeleteClassrooms= createAsyncThunk(
    "restore/delete/classrooms",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/classrooms/restore/${id}`);
            dispatch(deletedRestoreClassrooms(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const CreateChildClassroom = createAsyncThunk(
    "create/child/classroom",
    async (data:IChildClassRoomCreate,{rejectWithValue }) => {
        try {
            const response = await request.post("/classroom-equipments",data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const DeleteChildClassroom = createAsyncThunk(
    "delete/child/classroom",
    async (id:number,{rejectWithValue }) => {
        try {
            const response = await request.delete(`/classroom-equipments/${id}`);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)

const EditChildClassroom = createAsyncThunk(
    "edit/child/classroom",
    async (data:IEquipmentsPayload,{rejectWithValue }) => {
        try {
            const response = await request.put(`/classroom-equipments/${data.id}`,data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


export{
    GetClassrooms,
    SetClassrooms,
    EditClassrooms,
    DeleteClassrooms,
    GetDeleteClassrooms,
    RestoreDeleteClassrooms,
    CreateChildClassroom,
    DeleteChildClassroom,
    EditChildClassroom
}